<!-- 教师提问 -->
<template>
  <div>
    <div class="course_answer">
      <el-row class="mb20">
        <label style="margin-left: 20px;">班级：</label>
        <el-select @change="getStudentList()" clearable v-model="value" filterable placeholder="请选择">
          <template v-for="(item ,index) in classList">
            <el-option :key="index+'class'" :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
          </template>
        </el-select>
        <el-button type="primary" icon="el-icon-refresh" @click="randomGet(-1)">随机抽取</el-button>
      </el-row>
      <el-row style="max-height: 220px;overflow: auto;border: 1px solid #DEDEDE;padding: 10px;margin-bottom: 20px;">
        <template v-for="(item, index) in studentList">
          <span :key="index+'studentList'" class="studentInfo c_p" @click="randomGet(index)">
            <el-image class="answer_img" :src="user"></el-image>
            <p class="m0">{{item.studentName}}</p>
          </span>
        </template>
        <el-empty :image-size="20" style="padding: 12px 0;" v-if="studentList.length <= 0" description="暂无数据"></el-empty>
      </el-row>
      <el-row class="content_block">
        <el-row>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
            <el-table-column prop="teacherOpenCourseChatLogAddTime" header-align="center" align="center" label="提问时间" width="200">
            </el-table-column>
            <el-table-column prop="studentIdText" header-align="center" align="center" label="提问学生" width="200">
            </el-table-column>
            <el-table-column prop="chatLogSendTypeText" header-align="center" align="center" label="提问方式" width="200">
            </el-table-column>
            <el-table-column prop="className" header-align="center" align="center" label="所属班级" width="200">
            </el-table-column>
            <el-table-column prop="chatContent" header-align="center" align="center" label="提问内容">
              <template slot-scope="scope">
                <el-row v-html="scope.row.chatContent"></el-row>
              </template>
            </el-table-column>
            <el-table-column prop="replyContent" header-align="center" align="center" label="学生回答" width="200">
              <template v-slot:="scope">
                <el-row v-html="scope.row.replyContent"></el-row>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="studentScore" header-align="center" align="center" label="登记得分" width="120">
              <template slot-scope="scope">
                <el-input
                :disabled="$isEmpty(scope.row.replyContent)"
                 oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^\./g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')" v-model="scope.row.studentScore" @blur="setScore(scope.row)" placeholder="请输入分数"></el-input>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="page" :page-sizes="[8, 20, 50, 100]" :page-size="limit" background
              :hide-on-single-page="false" layout="sizes, prev, pager, next,jumper" :total="total">
            </el-pagination>
          </div>
        </el-row>
      </el-row>

      <!-- 提问对话框 -->
      <el-dialog title="提问" :visible.sync="user_questions_show" width="800px">
        <el-row class="mb10">
          <label style="float: left;">提问学生：{{questionsInfo.studentName}}</label>
          <i class="el-icon-refresh font20 c_p" @click="randomGet(-1)"
            style="color: red;float: left;margin-left: 20px;"></i>
        </el-row>
        <el-row class="mb10">
          <label>提问内容：</label>
        </el-row>
        <el-row class="mb40">
          <RichText ref="richText" v-if="user_questions_show" v-model="questionsInfo.forest_desc" />
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="user_questions_show = false">取 消</el-button>
          <el-button type="primary" @click="submitInfo">确 认</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import RichText from '@/components/RichText/index';
import {getClassInfo} from "@/common/getInfo"; //加载数据
export default {
    name: 'Answer',
    components: {
      RichText
    },
    props: {
      courseId: { //课程ID
        type: String,
        required: true
      }
    },
    data() {
      return {
        user: require("../../../../images/user/user.png"),
        value: '',
        searchInfo: "",
        tableData: [],

        total: 0,
        limit: 8,
        page: 1,
        user_questions_show: false,
        questionsInfo: {},
        studentList: [],
        classList: []
      }
    },
    created() {
      this.getInfo();
      this.getClassList();
      this.getStudentList();
    },
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.limit = val;
        this.getInfo();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page = val;
        this.getInfo();
      },
      getClassList(){
        getClassInfo({teacherOpenCourseId:this.courseId}).then(ret =>{ //根据课程ID获取班级信息
          if(ret.code == 0){
            this.classList = ret.data;
          }
        });
      },
      getStudentList(){
        this.randomGetUser({
          teacherOpenCourseId: this.courseId,
          schoolClassIds:this.value,
        });
      },
      getInfo() { //获取数据
        let param = {
          limit:this.limit,
          page:this.page,
          schoolClassIds:this.value,
          teacherOpenCourseId:this.courseId,
          chatLogSendTypePlural:"specify_ask,random_ask"
        }
        this.$post("/api/teacherOpenCourseChatLog/getPageList.do",param).then((ret) =>{
          if(ret.code == 0){
            this.total = Number(ret.count);
            this.tableData = ret.data;
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      },
      lookReply() { //查看回复

      },
      randomGet(index) {
        if(this.studentList.length == 0){
          this.$message({
            message: '暂无学生信息！',
            type: 'warning'
          });
          return;
        }
        if (index >= 0) {
          this.questionsInfo = this.studentList[index];
        } else {
          this.randomGetUser({
            teacherOpenCourseId: this.courseId,
            schoolClassIds:this.value,
            randomCount: 1
          });
        }
        this.questionsInfo.forest_desc = "";
        this.user_questions_show = true;

      },
      randomGetUser(param) { //随机
        this.$post("/api/teacherOpenCourseMergeStudent/randomStudentList.do", param).then((ret) => {
          if (ret.code == 0) {
            if (param.randomCount != 1) {
              this.studentList = ret.data;
            } else {
              this.questionsInfo = ret.data[0];
            }
          } else {
            this.$message({
              message: ret.msg,
              type: 'error'
            });
          }
        });
      },
      submitInfo() { //打开提问对话框
        if (this.$isEmpty(this.questionsInfo.forest_desc)) {
          this.$message({
            message: '请输入我问内容！',
            type: 'warning'
          });
          return;
        }
        let param = {
          teacherOpenCourseId: this.courseId,
          chatLogSendType:"random_ask",
          studentId: this.questionsInfo.studentId,
          chatContent: this.questionsInfo.forest_desc,
        }
        this.$postJSON("/api/teacherOpenCourseChatLog/add.do", param).then((ret) => {
          if (ret.code == 0) {
            this.getInfo();
            this.user_questions_show = false;
            this.$refs.richText.content = ""; //清空编辑框
            this.$message({
              message: '提交成功！',
              type: 'success'
            });
          } else {
            this.$message({
              message: ret.msg,
              type: 'error'
            });
          }
        });
      },
      setScore(item) { //设置得分
        if(this.$isEmpty(item.studentScore)){
          return;
        }
        let param = {
          teacherOpenCourseChatLogId: item.teacherOpenCourseChatLogId,
          studentScore:item.studentScore
        }
        this.$post("/api/teacherOpenCourseChatLog/setScore.do", param).then((ret) => {
          if (ret.code == 0) {
            this.$message({message: '提交成功！',type: 'success'});
            this.$emit("onSuccess_t");
          } else {
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      }
    }
  };
</script>
<style lang="less">
  .course_answer {
    padding: 20px;
    border: 1px solid #DEDEDE;

    .content_block {
      background-color: #ffffff;

      .title_img {
        width: 20px;
      }

      .class_img {
        float: left;
        margin-right: 10px;
      }

      .echarts_row {
        padding: 20px;
      }

      .block_time {
        display: initial;
        margin-left: 20px;
      }

      .el-calendar__body {
        th {
          border-top: 1px solid #E5E5E5;
          border-left: 1px solid #E5E5E5;
          background-color: #EFF2F7;
        }

        th:last-child {
          border-right: 1px solid #E5E5E5;
        }
      }
    }

    .studentInfo {
      float: left;
      text-align: center;
      margin-right: 20px;
    }

    .answer_img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/interaction/Answer.vue